import { defineStore } from 'pinia';
import { jwtDecode } from 'jwt-decode';

export const userLoginDataStorage = defineStore('userLoginDataStorage', {
    state: () => ({
        userLoginData: {}
    }),
    actions: {
        setUserLoginData(userLoginData) {
            this.userLoginData = userLoginData;
        }
    },
    getters: {
        getUserId: (state) => () => {
            return state.userLoginData?.userId;
        },
        getUserLoginData: (state) => () => {
            return state.userLoginData;
        },
        getUserMainPlanet: (state) => () => {
            return state.userLoginData?.mainPlanet;
        },
        getUserMainPlanetId: (state) => () => {
            return state.userLoginData.mainPlanet?.id;
        },
        getUserToken: (state) => () => {
            return state.userLoginData?.token ?? '';
        },
        getUserTokenExp: (state) => () => {
            const token = state.userLoginData?.token;
            if (undefined === token) {
                return 0;
            }

            const decodedToken = jwtDecode(token);
            return decodedToken.exp * 1000;
        },
        getUserMercureToken: (state) => () => {
            return state.userLoginData?.mercureToken;
        }
    },
    persist: {
        enabled: true,
        storage: sessionStorage
    }
});